import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Home, Search, RefreshCw, Package, AlertTriangle } from 'lucide-react'

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-950 px-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className="text-center max-w-md"
      >
        <div className="mb-8">
          <motion.div
            initial={{ rotate: -180 }}
            animate={{ rotate: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="inline-flex items-center justify-center w-32 h-32 rounded-full bg-neutral-100 dark:bg-neutral-800"
          >
            <AlertTriangle className="w-16 h-16 text-warning-500" />
          </motion.div>
        </div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.3 }}
          className="text-6xl font-bold text-neutral-900 dark:text-white mb-4"
        >
          ۴۰۴
        </motion.h1>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.3 }}
          className="text-2xl font-semibold text-neutral-900 dark:text-white mb-3"
        >
          صفحه یافت نشد
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.3 }}
          className="text-neutral-500 dark:text-neutral-400 mb-8 max-w-sm mx-auto"
        >
          متأسفیم! صفحی که به دنبال آن هستید وجود ندارد یا منتقل شده است.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.3 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary-600 text-white font-medium hover:bg-primary-700 transition-colors"
          >
            <Home className="w-5 h-5" />
            بازگشت به داشبورد
          </Link>

          <Link
            to="/inventory/products"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border border-neutral-300 dark:border-neutral-700 text-neutral-700 dark:text-neutral-300 font-medium hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors"
          >
            <Search className="w-5 h-5" />
            جستجوی کالا
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.3 }}
          className="mt-12 p-6 rounded-2xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800"
        >
          <h3 className="font-semibold text-neutral-900 dark:text-white mb-4">پیشنهادها:</h3>
          <ul className="space-y-2 text-sm text-neutral-600 dark:text-neutral-400 text-right">
            <li className="flex items-center gap-2">
              <Package className="w-4 h-4 text-primary-500 flex-shrink-0" />
              بررسی آدرس URL برای تایپ اشتباه
            </li>
            <li className="flex items-center gap-2">
              <Search className="w-4 h-4 text-primary-500 flex-shrink-0" />
              استفاده از جستجوی بالا برای یافتن کالا
            </li>
            <li className="flex items-center gap-2">
              <Home className="w-4 h-4 text-primary-500 flex-shrink-0" />
              بازگشت به داشبورد اصلی
            </li>
            <li className="flex items-center gap-2">
              <RefreshCw className="w-4 h-4 text-primary-500 flex-shrink-0" />
              بازآوری صفحه
            </li>
          </ul>
        </motion.div>
      </motion.div>
    </div>
  )
}